export default "__VITE_ASSET__CId87Tdx__"